<template>
  <v-tooltip
      open-delay='300'
      top
  >
    <template v-slot:activator="{on, attrs}">
      <v-icon
          v-bind="attrs"
          v-on="on"
          size="18"
      >
        $question-outlined
      </v-icon>
    </template>
    <span>
      {{ message }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "m-tooltip",
  props: {
    message: {
      type: String,
      default: ''
    }
  }

}
</script>

<style scoped>

</style>
